import { safeLocalStorage } from '../../utils/storage';
// Utilities for landing page components

// Pool of suggestive female names for adult platform
const femaleNames = [
    // Common first names with variations
    'Jessica', 'Jessica69', 'JessicaUK', 'Jessica_xxx', 'JessicaNaughty',
    'Sarah', 'Sarah21', 'Sarah_DE', 'SarahSexy', 'Sarah4u',
    'Emma', 'Emma69', 'EmmaHot', 'Emma_NL', 'EmmaXO',
    'Ashley', 'Ashley18', 'AshleyCA', 'AshleyWet', 'Ash_ley',
    'Amanda', 'Amanda_69', 'AmandaFR', 'AmandaKiss', 'Mandy69',
    'Michelle', 'Michelle22', 'MichelleAU', 'MichelleBad', 'Chelle_xxx',
    'Lisa', 'Lisa_69', 'LisaES', 'LisaNasty', 'Lisa4fun',
    'Jennifer', 'Jenny69', 'JenniferNZ', 'JennySlut', 'Jen_wild',
    'Nicole', 'Nicole21', 'NicoleIT', 'NikkiHot', 'Nic69',
    'Stephanie', 'Steph69', 'StephanieSE', 'StephSlut', 'Steph_bad',
    
    // Suggestive screen names
    'HotMILF69', 'NaughtyGirl21', 'WetKitty', 'BadGirlXXX', 'SluttyBabe',
    'DirtySecret', 'KinkyMinx', 'HornyHousewife', 'NastyNikki', 'WildCherry',
    'SexyVixen', 'DirtyDiana', 'NaughtyNurse', 'BadTeacher', 'SluttySecretary',
    'HotwifeUK', 'MILFnextdoor', 'Cumslut69', 'AnalQueen', 'DeepThroatBabe',
    'SquirtingMama', 'BBWGoddess', 'TightPussy21', 'BigTitsGirl', 'AsianDoll',
    'LatinLover', 'EbonyQueen', 'RedheadSlut', 'BlondeBarbie', 'BustyBrunette',
    
    // Fetish/kink related
    'SubSlut', 'DomMistress', 'FootFetishBabe', 'RoleplayQueen', 'BDSMgirl',
    'SpankMe69', 'TiedUpToy', 'LeatherLady', 'WhipMeHard', 'ChokeMeDaddy',
    'CuckoldWife', 'Hotwife4BBC', 'GangbangGirl', 'DPqueen', 'ThreesomeLover',
    
    // Classic adult names with numbers/variations
    'Candy69', 'CandyAU', 'SweetCandy', 'Angel_69', 'AngelUK', 'DarkAngel',
    'Kitten21', 'KittenDE', 'SexyKitten', 'Cherry69', 'CherryCA', 'PopMyCherry',
    'Honey_69', 'HoneyNL', 'SweetHoney', 'Bella69', 'BellaIT', 'BellaBad',
    'Scarlett21', 'ScarlettFR', 'ScarlettSin', 'Raven69', 'RavenES', 'DarkRaven',
    
    // More realistic variations
    'Amy_2023', 'Rachel_xxx', 'Lauren69', 'Megan_hot', 'Emily4u',
    'Samantha21', 'Katie_bad', 'Sophie69', 'Chloe_wet', 'Grace_xxx',
    'Olivia_69', 'Isabella21', 'Sophia_hot', 'Madison69', 'Ava_naughty'
];

// Major cities by region
const cities = {
    us: [
        'New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia',
        'San Antonio', 'San Diego', 'Dallas', 'Miami', 'Atlanta', 'Boston',
        'Seattle', 'Denver', 'Las Vegas', 'Portland', 'Nashville', 'Austin'
    ],
    uk: [
        'London', 'Manchester', 'Birmingham', 'Leeds', 'Glasgow', 'Liverpool',
        'Edinburgh', 'Bristol', 'Cardiff', 'Belfast', 'Newcastle', 'Nottingham'
    ],
    ca: [
        'Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Ottawa', 'Edmonton',
        'Winnipeg', 'Quebec City', 'Hamilton', 'Victoria'
    ],
    au: [
        'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast',
        'Newcastle', 'Canberra', 'Hobart', 'Darwin'
    ],
    nl: [
        'Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven', 'Groningen',
        'Tilburg', 'Almere', 'Breda', 'Nijmegen', 'Arnhem', 'Haarlem'
    ],
    fr: [
        'Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes',
        'Montpellier', 'Strasbourg', 'Bordeaux', 'Lille', 'Rennes', 'Reims'
    ],
    de: [
        'Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt', 'Stuttgart',
        'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen', 'Bremen', 'Dresden'
    ],
    es: [
        'Madrid', 'Barcelona', 'Valencia', 'Seville', 'Zaragoza', 'Málaga',
        'Murcia', 'Palma', 'Las Palmas', 'Bilbao', 'Alicante', 'Córdoba'
    ],
    at: [
        'Vienna', 'Graz', 'Linz', 'Salzburg', 'Innsbruck', 'Klagenfurt',
        'Villach', 'Wels', 'St. Pölten', 'Dornbirn'
    ],
    ch: [
        'Zurich', 'Geneva', 'Basel', 'Lausanne', 'Bern', 'Winterthur',
        'Lucerne', 'St. Gallen', 'Lugano', 'Biel'
    ],
    it: [
        'Rome', 'Milan', 'Naples', 'Turin', 'Palermo', 'Genoa',
        'Bologna', 'Florence', 'Bari', 'Catania', 'Venice', 'Verona'
    ],
    nz: [
        'Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga',
        'Napier-Hastings', 'Dunedin', 'Palmerston North', 'Nelson', 'Rotorua'
    ],
    ie: [
        'Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford', 'Drogheda',
        'Dundalk', 'Swords', 'Bray', 'Navan'
    ],
    se: [
        'Stockholm', 'Gothenburg', 'Malmö', 'Uppsala', 'Västerås', 'Örebro',
        'Linköping', 'Helsingborg', 'Jönköping', 'Norrköping'
    ]
};

// Get random element from array
export const getRandomElement = <T>(arr: T[]): T => {
    return arr[Math.floor(Math.random() * arr.length)];
};

// Get random number in range
export const getRandomInRange = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Get nearby cities based on user location
const getNearbyCities = (userLocation: any) => {
    if (!userLocation || !userLocation.country) {
        return Object.values(cities).flat();
    }
    
    // Get country ISO code
    const countryISO = (userLocation.country?.iso || userLocation.country || '').toLowerCase();
    const userCity = userLocation.town?.name || userLocation.city;
    
    // Get cities from user's country based on ISO code
    let nearbyCities: string[] = cities[countryISO as keyof typeof cities] || [];
    
    // Handle special case for UK (gb/uk)
    if (!nearbyCities.length && (countryISO === 'gb' || countryISO === 'uk')) {
        nearbyCities = cities.uk;
    }
    
    // Default to all cities if country not recognized
    if (!nearbyCities.length) {
        nearbyCities = Object.values(cities).flat();
    }
    
    // If user has a city, add it and nearby variations
    if (userCity) {
        // Add the user's city if not already in list
        if (!nearbyCities.includes(userCity)) {
            nearbyCities.unshift(userCity);
        }
        
        // For more realistic feel, duplicate nearby cities to increase their frequency
        const userCityIndex = nearbyCities.indexOf(userCity);
        if (userCityIndex !== -1) {
            // Add cities around the user's city more frequently
            const nearbyRange = 3;
            for (let i = Math.max(0, userCityIndex - nearbyRange); 
                 i <= Math.min(nearbyCities.length - 1, userCityIndex + nearbyRange); 
                 i++) {
                nearbyCities.push(nearbyCities[i]);
            }
        }
    }
    
    return nearbyCities;
};

// Generate random member activity
export const generateActivity = (userLocation?: any, t?: any) => {
    // Always use female names for adult platform
    const name = getRandomElement(femaleNames);
    
    // Get location-relevant cities
    const relevantCities = getNearbyCities(userLocation);
    const city = getRandomElement(relevantCities);
    
    const actions = t ? [
        t('landing.activity_just_joined'),
        t('landing.activity_online_now'),
        t('landing.activity_updated_profile'),
        t('landing.activity_uploaded_photo')
    ] : ['just joined', 'is online now', 'updated their profile', 'uploaded a new photo'];
    const action = getRandomElement(actions);
    
    // Sometimes add distance for nearby cities
    let displayCity = city;
    const userCityName = userLocation?.town?.name || userLocation?.city;
    if (userCityName && city !== userCityName && Math.random() > 0.5) {
        const distances = ['5', '10', '15'];
        const distance = getRandomElement(distances);
        const prefix = t ? t('landing.activity_km_from', { distance }) : `${distance} km from`;
        const nearText = t ? t('landing.activity_near') : 'near';
        const distanceText = Math.random() > 0.5 ? prefix : nearText;
        displayCity = `${distanceText} ${userCityName}`;
    }
    
    return {
        name,
        city: displayCity,
        action,
        timestamp: new Date().getTime()
    };
};

// Get online member count with persistence
export const getOnlineCount = (): number => {
    const stored = safeLocalStorage.getItem('landing_online_count');
    const storedTime = safeLocalStorage.getItem('landing_online_count_time');
    const now = new Date().getTime();
    
    // Refresh count every hour
    if (!stored || !storedTime || now - parseInt(storedTime) > 3600000) {
        const count = getRandomInRange(2500, 4000);
        safeLocalStorage.setItem('landing_online_count', count.toString());
        safeLocalStorage.setItem('landing_online_count_time', now.toString());
        return count;
    }
    
    return parseInt(stored);
};

// Update online count (small fluctuation)
export const updateOnlineCount = (currentCount: number): number => {
    const change = getRandomInRange(-5, 5);
    const newCount = Math.max(2000, Math.min(5000, currentCount + change));
    safeLocalStorage.setItem('landing_online_count', newCount.toString());
    return newCount;
};

// Get 15 minute countdown
export const getTimeUntilMidnight = (): { hours: number; minutes: number; seconds: number } => {
    // Get stored end time or create new one
    const storedEndTime = safeLocalStorage.getItem('landing_offer_end_time');
    const now = new Date().getTime();
    
    let endTime: number;
    if (!storedEndTime || parseInt(storedEndTime) <= now) {
        // Create new 15 minute countdown
        endTime = now + (15 * 60 * 1000); // 15 minutes from now
        safeLocalStorage.setItem('landing_offer_end_time', endTime.toString());
    } else {
        endTime = parseInt(storedEndTime);
    }
    
    const diff = Math.max(0, endTime - now);
    
    return {
        hours: Math.floor(diff / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000)
    };
};

// Format time for display
export const formatTime = (time: { hours: number; minutes: number; seconds: number }): string => {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(time.hours)}:${pad(time.minutes)}:${pad(time.seconds)}`;
};

// Detect user's region based on timezone
export const detectRegion = (): 'us' | 'uk' | 'ca' | 'au' => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    if (timezone.includes('America')) {
        if (timezone.includes('Toronto') || timezone.includes('Vancouver')) return 'ca';
        return 'us';
    }
    if (timezone.includes('Europe/London')) return 'uk';
    if (timezone.includes('Australia')) return 'au';
    
    return 'us'; // default
};

// Get cities for user's region
export const getLocalCities = (): string[] => {
    const region = detectRegion();
    return cities[region];
};